// extracted by mini-css-extract-plugin
export default {"container":"BottomBar_container__Wn9q1"};